import { render, staticRenderFns } from "./TalkManagement.vue?vue&type=template&id=624982c6&scoped=true"
import script from "./TalkManagement.vue?vue&type=script&lang=js"
export * from "./TalkManagement.vue?vue&type=script&lang=js"
import style0 from "./TalkManagement.vue?vue&type=style&index=0&id=624982c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624982c6",
  null
  
)

export default component.exports